module.exports = __webpack_public_path__ + "img/4.f0e91820.png";